export default class ProgressGameModel {

    constructor(variableManager) {
        this._variableManager = variableManager;

        this._updatedDashboardData = true;
        this._updatedDashboardRCCE = true;
    }

    addPath(value) {
        if (this.path) {
            this.path += value;
        } else {
            this.path = value;
        }
        this._variableManager.setVariable(`PATH_${this._path}`, true);
    }

    /** @returns {number} chapter nr, starting at 1 */
    get chapter() {
        return this._chapter;
    }

    /** @param value {number} chapter nr, starting at 1 */
    set chapter(value) {
        this._chapter = value;
    }

    /** @returns {number} week nr, starting at 1 */
    get week() {
        return this._week;
    }

    set week(value) {
        if (this._week != value) {
            this.updatedDashboardData = true;
            this._week = value;
        }
    }

    /** @returns {} */
    get path() {
        return this._path;
    }

    set path(value) {
        this._path = value;
    }

    get updatedDashboardData() {
        return this._updatedDashboardData;
    }

    set updatedDashboardData(value) {
        return this._updatedDashboardData = value;
    }

    get updatedDashboardRCCE() {
        return this._updatedDashboardRCCE;
    }

    set updatedDashboardRCCE(value) {
        return this._updatedDashboardRCCE = value;
    }

    toObject() {
        return {
            week: this.week,
            chapter: this.chapter,
            path: this.path
        }
    }

    fromObject(obj) {
        this.chapter = obj.chapter;
        this.week = obj.week;
        this.path = obj.path;
    }
}